import { render, staticRenderFns } from "./PrintPosTk.vue?vue&type=template&id=6dfa71ba&scoped=true"
import script from "./PrintPosTk.vue?vue&type=script&lang=js"
export * from "./PrintPosTk.vue?vue&type=script&lang=js"
import style0 from "./PrintPosTk.vue?vue&type=style&index=0&id=6dfa71ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfa71ba",
  null
  
)

export default component.exports